import { render } from "./tagManagement.vue?vue&type=template&id=52e5c1bd&scoped=true"
import script from "./tagManagement.vue?vue&type=script&lang=js"
export * from "./tagManagement.vue?vue&type=script&lang=js"

import "./tagManagement.vue?vue&type=style&index=0&id=52e5c1bd&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52e5c1bd"]])

export default __exports__